export default __webpack_public_path__ + "static/media/logoCPNegro.fa3c6996.png";